import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/img/loading.svg';
var _hoisted_1 = { class: "post-outter-container" };
var _hoisted_2 = ["id"];
var _hoisted_3 = ["alt"];
var _hoisted_4 = ["src", "alt"];
var _hoisted_5 = {
    class: "post-summary",
    style: { "margin": "0.5rem", "height": "100%", "position": "relative", "display": "flex", "flex-direction": "column", "flex-grow": "1", "width": "72.5%" }
};
var _hoisted_6 = ["title"];
var _hoisted_7 = { class: "post-footer" };
var _hoisted_8 = { class: "post-tags" };
var _hoisted_9 = { class: "post-tag" };
var _hoisted_10 = ["title"];
var _hoisted_11 = {
    key: 0,
    class: "post-modal-loading",
    sizr: "2rem"
};
var _hoisted_12 = {
    key: 1,
    class: "post-history-data"
};
var _hoisted_13 = { class: "history-year-part" };
var _hoisted_14 = { class: "history-detail-content" };
var _hoisted_15 = ["onClick"];
var _hoisted_16 = { class: "month-day-time-container" };
var _hoisted_17 = { class: "month-day-time" };
var _hoisted_18 = { class: "diff-detail" };
var _hoisted_19 = { key: 1 };
var _hoisted_20 = {
    key: 0,
    class: "ribbon-3 ribbon-3-delete"
};
var _hoisted_21 = {
    key: 1,
    class: "ribbon-3 ribbon-3-in-edit"
};
import { computed, onMounted, ref, toRef } from "vue";
import CustomSVG from "@/components/custom/CustomSVG.vue";
import NullView from "@/views/tipViews/Null.vue";
import tools from "@/utils/tools";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostBoxRow',
    props: {
        propPost: Object,
    },
    setup: function (__props) {
        //待完善：未加载完成时禁用hover
        var isLoadImg = ref(false);
        var showModal = ref(false), isModalLoaded = ref(false);
        var optionsIconSize = ref("25");
        var isShowOptions = ref(false);
        var optionsGroupItem = ref(null);
        var showOptionsStyle = computed(function () {
            if (!optionsGroupItem.value)
                return {};
            return {
                // right: `${
                //   isShowOptions.value
                //     ? 0
                //     : -(optionsGroupItem.value as HTMLElement).offsetWidth // 或 ref<HTMLElement | null>(null)
                // }px`,
                right: isShowOptions.value
                    ? "0px"
                    : "calc(-".concat(optionsGroupItem.value.offsetWidth // 或 ref<HTMLElement | null>(null)
                    , "px - ").concat(getComputedStyle(optionsGroupItem.value).getPropertyValue("--options-folder-gap"), ")"),
            };
        });
        var attribute = __props;
        var post = toRef(attribute, "propPost");
        if (!post.value)
            throw new Error("post is required");
        var postHistoryList = ref([]);
        var getPostHistory = function () {
            var _a;
            // tools.jumptoLocal(`/post/md/${post.value?.id}`);
            showModal.value = true;
            isModalLoaded.value = false;
            api.request
                .get("/gethistoryupdate?postID=".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id))
                .then(function (res) {
                postHistoryList.value = res.data;
                isModalLoaded.value = true;
            })
                .catch(function (err) {
                window.$notifyError("获取历史更新失败", err.response.msg);
            });
        };
        var createExistingPostDraft = function () {
            if (!post.value) {
                window.$message.error("文章信息获取失败");
                return;
            }
            var formData = new FormData();
            formData.append("id", String(post.value.id));
            api.request
                .quickPost("/createexistspostdraft", formData)
                .then(function (res) {
                if (post.value) {
                    post.value.is_has_draft = true;
                }
                showModal.value = false;
                tools.jumptoLocal("/edit/post-edit?uuid=".concat(res.data));
            })
                .catch(function (err) {
                window.$notifyError("创建草稿失败", err.response.msg);
            });
        };
        var createDraft = function () {
            var _a;
            if (!post.value) {
                window.$message.error("文章信息获取失败");
                return;
            }
            if (post.value.is_has_draft) {
                ///////////////////////////////////////////////////////////////////////////
                api.request
                    .get("/getexistingpostdraft?postID=".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id))
                    .then(function (res) {
                    if (post.value) {
                        post.value.is_has_draft = true;
                    }
                    tools.jumptoLocal("/edit/post-edit?uuid=".concat(res.data));
                })
                    .catch(function (err) {
                    window.$notifyError("获取草稿失败", err.response.msg);
                });
            }
            else {
                createExistingPostDraft();
            }
        };
        var deletePost = function () {
            if (!post.value) {
                window.$message.error("文章信息获取失败");
                return;
            }
            var formData = new FormData();
            formData.append("postID", String(post.value.id));
            api.request
                .quickPost("/deletepost", formData)
                .then(function (res) {
                var resp = res;
                if (!post.value) {
                    window.$message.error("文章信息获取失败");
                    return;
                }
                post.value.is_delete = true;
                window.$message.success("删除成功");
            })
                .catch(function (err) {
                window.$notifyError("删除文章失败", err.response.msg);
            });
        };
        var recoverPost = function () {
            if (!post.value) {
                window.$message.error("文章信息获取失败");
                return;
            }
            var formData = new FormData();
            formData.append("postID", String(post.value.id));
            api.request
                .quickPost("/recoverpost", formData)
                .then(function (res) {
                if (!post.value) {
                    window.$message.error("文章信息获取失败");
                    return;
                }
                post.value.is_delete = false;
                window.$message.success("恢复成功");
            })
                .catch(function (err) {
                window.$notifyError("恢复文章失败", err.response.msg);
            });
        };
        var jumptoPostHistoryDetail = function (uuid) {
            var _a;
            tools.jumpto("/backup/".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id, "/").concat(uuid));
        };
        function onLoad() {
            isLoadImg.value = true;
        }
        function onError() {
            window.$message.error("图片加载失败");
        }
        onMounted(function () {
            var _a, _b, _c, _d;
            var instance = document.querySelector("#post-".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id));
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-id", String((_b = post.value) === null || _b === void 0 ? void 0 : _b.id));
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-title", ((_c = post.value) === null || _c === void 0 ? void 0 : _c.title) || "");
            instance === null || instance === void 0 ? void 0 : instance.setAttribute("post-category", ((_d = post.value) === null || _d === void 0 ? void 0 : _d.category) || "");
        });
        return function (_ctx, _cache) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            var _component_n_card = _resolveComponent("n-card");
            var _component_n_modal = _resolveComponent("n-modal");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: "post-container",
                    id: "post-".concat((_a = post.value) === null || _a === void 0 ? void 0 : _a.id),
                    onClick: getPostHistory
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'postimg-container',
                            { 'postimg-container-no-mask': !isLoadImg.value },
                        ])
                    }, [
                        (!isLoadImg.value)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _imports_0,
                                class: "post-cover-img-not-load",
                                alt: (_b = post.value) === null || _b === void 0 ? void 0 : _b.title
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("img", {
                            src: "/md/".concat((_c = post.value) === null || _c === void 0 ? void 0 : _c.id, "/").concat((_d = post.value) === null || _d === void 0 ? void 0 : _d.cover_filename),
                            onLoad: onLoad,
                            onError: onError,
                            class: "post-cover-img",
                            alt: (_e = post.value) === null || _e === void 0 ? void 0 : _e.title
                        }, null, 40, _hoisted_4), [
                            [_vShow, isLoadImg.value]
                        ])
                    ], 2),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", {
                            class: "post-title",
                            title: (_f = post.value) === null || _f === void 0 ? void 0 : _f.title
                        }, _toDisplayString((_g = post.value) === null || _g === void 0 ? void 0 : _g.title), 9, _hoisted_6),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_h = post.value) === null || _h === void 0 ? void 0 : _h.tags, function (item, index) {
                                    return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                            t: "1725449131372",
                                            class: "icon",
                                            viewBox: "0 0 1024 1024",
                                            version: "1.1",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            "p-id": "1454"
                                        }, [
                                            _createElementVNode("path", {
                                                d: "M428.63173571 98.52447645a51.78153127 51.78153127 0 0 1 41.94304 60.01479347L444.78757334 304.87387614h205.46911407l28.99765688-164.30279703a51.78153127 51.78153127 0 1 1 102.00961661 17.96819081L755.47675853 304.87387614H874.47071645a51.78153127 51.78153127 0 0 1 0 103.56306254h-137.27283913l-36.50597926 207.12612264H822.68918518a51.78153127 51.78153127 0 0 1 0 103.56306254h-140.2761671l-27.02995911 153.32511289a51.78153127 51.78153127 0 0 1-102.00961541-17.96819202L577.24472889 719.12612386H371.72383289l-27.02995911 153.32511289a51.78153127 51.78153127 0 0 1-102.0096154-17.96819202L266.5555437 719.12612386H149.52928355a51.78153127 51.78153127 0 0 1 0-103.56306254h135.25335943l36.55775997-207.12612264H201.31081482a51.78153127 51.78153127 0 1 1 0-103.56306254h138.2566874l28.99765688-164.30279703a51.78153127 51.78153127 0 0 1 60.06657661-42.04660266zM595.42004622 615.56306132l36.55776119-207.12612264h-205.520896l-36.50597925 207.12612264h205.46911406z",
                                                "p-id": "1455",
                                                fill: "#bfbfbf"
                                            })
                                        ], -1)),
                                        _createElementVNode("span", null, _toDisplayString(item), 1)
                                    ]));
                                }), 256))
                            ]),
                            _createElementVNode("div", {
                                class: "post-datetime",
                                title: _unref(tools).formatDatetime(new Date(((_j = post.value) === null || _j === void 0 ? void 0 : _j.create_time) || ''))
                            }, _toDisplayString(_unref(tools).countHowManyTimesAgo(((_k = post.value) === null || _k === void 0 ? void 0 : _k.create_time) || "")), 9, _hoisted_10)
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "draft-info-operations",
                        onMouseenter: _cache[0] || (_cache[0] = function ($event) { return (isShowOptions.value = true); }),
                        onMouseleave: _cache[1] || (_cache[1] = function ($event) { return (isShowOptions.value = false); }),
                        style: _normalizeStyle(showOptionsStyle.value)
                    }, [
                        _createVNode(_component_n_icon, {
                            size: optionsIconSize.value,
                            class: "draft-options-show-icon-container",
                            color: "var(--font-color-reverse)"
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("i", {
                                    class: _normalizeClass([
                                        'fa-solid',
                                        'fa-angle-left',
                                        'draft-options-group-trigger-icon',
                                        { 'draft-options-group-trigger-icon-show': isShowOptions.value },
                                    ])
                                }, null, 2)
                            ]; }),
                            _: 1
                        }, 8, ["size"]),
                        _createElementVNode("div", {
                            class: "draft-options-container",
                            ref_key: "optionsGroupItem",
                            ref: optionsGroupItem
                        }, [
                            _createElementVNode("div", {
                                class: "draft-options-item draft-options-delete",
                                onClick: _withModifiers(getPostHistory, ["stop"])
                            }, [
                                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(_component_n_button, {
                                            quaternary: "",
                                            circle: "",
                                            size: "large"
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, {
                                                    size: optionsIconSize.value,
                                                    color: "var(--font-color-reverse)"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(CustomSVG, { icon: "HistoryEduFilled" })
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["size"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _cache[5] || (_cache[5] = _createTextVNode(" 查看历史更新 "))
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", {
                                class: "draft-options-item draft-item-to-top",
                                onClick: _withModifiers(createDraft, ["stop"])
                            }, [
                                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(_component_n_button, {
                                            quaternary: "",
                                            circle: "",
                                            size: "large"
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, {
                                                    size: optionsIconSize.value,
                                                    color: "var(--font-color-reverse)"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(CustomSVG, { icon: "GitPullRequestDraft" })
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["size"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () {
                                        var _a;
                                        return [
                                            _createTextVNode(" " + _toDisplayString(((_a = post.value) === null || _a === void 0 ? void 0 : _a.is_has_draft)
                                                ? "前往该文章已存在的更新草稿"
                                                : "为此文章创建更新草稿"), 1)
                                        ];
                                    }),
                                    _: 1
                                })
                            ]),
                            (!((_l = post.value) === null || _l === void 0 ? void 0 : _l.is_delete))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "draft-options-item draft-options-release",
                                    onClick: _withModifiers(deletePost, ["stop"])
                                }, [
                                    _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                        trigger: _withCtx(function () { return [
                                            _createVNode(_component_n_button, {
                                                quaternary: "",
                                                circle: "",
                                                size: "large"
                                            }, {
                                                icon: _withCtx(function () { return [
                                                    _createVNode(_component_n_icon, {
                                                        size: optionsIconSize.value,
                                                        color: "var(--font-color-reverse)"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(CustomSVG, { icon: "Delete24Filled" })
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["size"])
                                                ]; }),
                                                _: 1
                                            })
                                        ]; }),
                                        default: _withCtx(function () { return [
                                            _cache[6] || (_cache[6] = _createTextVNode(" 删除文章 "))
                                        ]; }),
                                        _: 1
                                    })
                                ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "draft-options-item draft-options-release",
                                    onClick: _withModifiers(recoverPost, ["stop"])
                                }, [
                                    _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                        trigger: _withCtx(function () { return [
                                            _createVNode(_component_n_button, {
                                                quaternary: "",
                                                circle: "",
                                                size: "large"
                                            }, {
                                                icon: _withCtx(function () { return [
                                                    _createVNode(_component_n_icon, {
                                                        size: optionsIconSize.value,
                                                        color: "var(--font-color-reverse)"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(CustomSVG, { icon: "ApprovalsApp32Filled" })
                                                        ]; }),
                                                        _: 1
                                                    }, 8, ["size"])
                                                ]; }),
                                                _: 1
                                            })
                                        ]; }),
                                        default: _withCtx(function () { return [
                                            _cache[7] || (_cache[7] = _createTextVNode(" 恢复文章 "))
                                        ]; }),
                                        _: 1
                                    })
                                ]))
                        ], 512)
                    ], 36),
                    _createVNode(_component_n_modal, {
                        show: showModal.value,
                        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) { return ((showModal).value = $event); })
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_n_card, {
                                style: { "width": "600px" },
                                title: "历史更新",
                                bordered: false,
                                size: "huge",
                                role: "dialog",
                                "aria-modal": "true",
                                class: "post-box-modal"
                            }, {
                                "header-extra": _withCtx(function () { return [
                                    _createVNode(_component_n_icon, {
                                        size: "1.6rem",
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (showModal.value = false); })
                                    }, {
                                        default: _withCtx(function () { return _cache[8] || (_cache[8] = [
                                            _createElementVNode("i", { class: "fa-solid fa-square-xmark fa-close-style" }, null, -1)
                                        ]); }),
                                        _: 1
                                    })
                                ]; }),
                                default: _withCtx(function () { return [
                                    (!isModalLoaded.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _createVNode(CustomSVG, { icon: "SmallLoading" })
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            (postHistoryList.value.length !== 0)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(postHistoryList.value, function (historyItem, index) {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass([
                                                            'post-history-item',
                                                            {
                                                                'history-item-diff-year-gap': index > 0 &&
                                                                    new Date(historyItem.releaseTime.replace(/Z$/, '')).getFullYear() !==
                                                                        new Date(postHistoryList.value[index - 1].releaseTime.replace(/Z$/, '')).getFullYear(),
                                                            },
                                                            {
                                                                'history-item-diff-year-gap-upper': index < postHistoryList.value.length - 1 &&
                                                                    new Date(historyItem.releaseTime.replace(/Z$/, '')).getFullYear() !==
                                                                        new Date(postHistoryList.value[index + 1].releaseTime.replace(/Z$/, '')).getFullYear(),
                                                            },
                                                        ])
                                                    }, [
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString("".concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getFullYear(), "\u5E74")), 1),
                                                        _createElementVNode("div", _hoisted_14, [
                                                            _createElementVNode("div", {
                                                                class: "history-diff-box",
                                                                onClick: function ($event) { return (jumptoPostHistoryDetail(historyItem.itemID)); }
                                                            }, [
                                                                _createElementVNode("div", _hoisted_16, [
                                                                    _createElementVNode("span", _hoisted_17, _toDisplayString("".concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getMonth() + 1, "\u6708").concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getDate(), "\u65E5 ").concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getHours(), "\u65F6").concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getMinutes(), "\u5206").concat(new Date(historyItem.releaseTime.replace(/Z$/, "")).getSeconds(), "\u79D2")), 1)
                                                                ]),
                                                                _createElementVNode("span", _hoisted_18, _toDisplayString(historyItem.diff), 1)
                                                            ], 8, _hoisted_15),
                                                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "history-item-dot" }, null, -1))
                                                        ])
                                                    ], 2));
                                                }), 256))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createVNode(NullView, { size: "50%" })
                                                ]))
                                        ]))
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }, 8, ["show"])
                ], 8, _hoisted_2),
                ((_m = post.value) === null || _m === void 0 ? void 0 : _m.is_delete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[10] || (_cache[10] = [
                        _createElementVNode("span", null, "已删除", -1)
                    ])))
                    : _createCommentVNode("", true),
                ((_o = post.value) === null || _o === void 0 ? void 0 : _o.is_has_draft)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[11] || (_cache[11] = [
                        _createElementVNode("span", null, "编辑中", -1)
                    ])))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
